export const DATESTAMP_MONTH_DATE_HIGHLIGHT = 'month_date_highlight';
